import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors } from '../../interfaces/Conference';
import { Description, Link, Title, TitleSymbol, Wrapper } from './ConferencePrivacy.elements';

interface ConferenceProps {
    colors?: IColors;
}

const ConferencePrivacyTemplate: FC<ConferenceProps> = ({ colors }) => {
    const { t } = useTranslations();

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.NOTICERECORDING}`}>
            <Title colors={colors}>
                {t('conference.component.digitalRecordInfo.title')}
                <TitleSymbol colors={colors} />
            </Title>
            <Description>
                V rámci oprávnených záujmov prevádzkovateľa, ktorým je spoločnosť Poradca podnikateľa, spol. s r. o.,
                Martina Rázusa 23A, 010 01 Žilina, IČO: 31 592 503, S-EPI, s. r. o., Martina Rázusa 23A/8336, 010 01
                Žilina, IČO: 36 014 991, EUROKÓDEX, s. r. o., Martina Rázusa 23A, 010 01 Žilina, IČO: 44 871 3842, bude
                o účastníkoch a zaujímavých momentoch podujatia v zmysle čl. 6 ods. 1 písm. f) všeobecného nariadenia o
                ochrane údajov vyhotovená fotodokumentácia a videozáznamy, ktoré môžu byť následne použité na propagáciu
                aktivít prevádzkovateľa. Napriek tomu, že vyhotovenie uvedenej dokumentácie nie je podmienené súhlasom
                dotknutej osoby, rešpektujeme váš prípadný nezáujem o snímanie vašej osoby.
            </Description>

            <Description>
                V uvedenom prípade informujte pri registrácii niektorú z našich referentiek alebo nám svoj nesúhlas
                zašlite na emailovú adresu{' '}
                <Link colors={colors} href="mailto:sinska@pp.sk">
                    sinska@pp.sk
                </Link>{' '}
                . Viac informácií o zásadách ochrany osobných údajov nájdete v časti{' '}
                <Link colors={colors} href="https://www.zakon.sk/podmienky-spracovania-ou.xhtml" target="_blank">
                    Podmienky spracovania osobných údajov
                </Link>
                .
            </Description>
        </Wrapper>
    );
};

export default ConferencePrivacyTemplate;
